/** Alinhado ao CustomTabBar do app mobile (M3 Expressive). */
import { LIGHT_TAB_COLORS } from "./tabBarLayout";

export {
  TAB_BAR_CONTENT_HEIGHT as contentHeight,
  CENTER_BUTTON_SIZE as centerButtonSize,
  SIDE_ICON_SIZE as sideIconSize,
  TAB_BAR_FLOAT_MARGIN_H as floatMarginH,
  TAB_BAR_FLOAT_MARGIN_BOTTOM as floatMarginBottom,
  TAB_BAR_FLOAT_RADIUS as floatRadius,
  TAB_BAR_COLLAPSED_WIDTH as collapsedWidth,
  LIGHT_TAB_COLORS,
  getTabBarTotalHeight,
} from "./tabBarLayout";

/** @deprecated Use LIGHT_TAB_COLORS — mantido para imports legados. */
export const TAB_BAR = {
  navbarBg: LIGHT_TAB_COLORS.navbarBg,
  primary: LIGHT_TAB_COLORS.primary,
  secondary: LIGHT_TAB_COLORS.secondary,
  white: LIGHT_TAB_COLORS.white,
  contentHeight: 64,
  centerButtonSize: 60,
  sideIconSize: 28,
  floatMarginH: 16,
  floatMarginBottom: 12,
  floatRadius: 28,
  collapsedWidth: 92,
} as const;
